import React from 'react';
import {Redirect}  from 'react-router-dom'
import '../../../../styles/requestConfirmed.css';


export default class RequestConfirmed extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            browseOtherArtworks : false
        }
    }
    handleBrowseOtherArtworksClick(){
        this.setState({
            browseOtherArtworks : true
        })
    }

    render() {
if(this.state.browseOtherArtworks){
    return(
        <Redirect push to="/" />
    )
}

        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    {this.props.heading}
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>
                            <div className="col-sm-6 UploadPaintingCard text-center no-margin" style = {{marginBottom : "10%"}}>
                                <img className="success-gold" src={require("../../../../assets/success_gold_png.png")}/>

                                <p className="success-text">{this.props.message}</p>

                                <button className="btn-black height-48" onClick={this.handleBrowseOtherArtworksClick.bind(this)}>
                                    Home
                                </button>

                            </div>

                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/resetPassword/email_sent.js